import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "Components/Pages/UserProfile/UserProfile/UserProfileTabs/AccountDetailsTab/styles";
import AccountDetailsGeneral from "./AccountDetailsGeneral/AccountDetailsGeneral";
import AccountDetailsBanking from "./AccountDetailsBanking/AccountDetailsBanking";
import { DPEmployeeProfile } from "Shared/types/EmployeeProfiles";

const AccountDetailsTab = (props: DPEmployeeProfile) => {
  const {
    employee,
    partnerCanceledAt,
    dpaOnFile,
  } = props;
  const classes = useStyles();
  return (
    <Box id="account-details">
      <Typography className={classes.title} variant="h3">
        GENERAL
      </Typography>
      <AccountDetailsGeneral {...props} />
      <Typography className={classes.title} variant="h3">
        BANKING
      </Typography>
      <AccountDetailsBanking
        partnerCanceledAt={partnerCanceledAt}
        providerBankAccount={employee.providerBankAccount}
        userBankAccounts={employee.userBankAccounts?.items || []}
        isDPAccountOnPayroll={dpaOnFile}
      />
    </Box>
  );
};

export default AccountDetailsTab;
